export default {
    props: ['banks-list', 'current-selected-bank-id', 'assoc-banks'],
    data() {
        return {
            selected_bank: {},
            selected_banks: [],
            selected_bank_ids: [],
            selected_bank_id: null
        };
    },
    mounted() {
        if (this.currentSelectedBankId) {
            this.selected_bank = this.banksList.filter((v) => { return v.id == this.currentSelectedBankId });
            this.selected_bank_id = this.currentSelectedBankId;
        }
        this.selected_banks = this.assocBanks
    },
    methods: {
        getSelected() {
            this.selected_bank_id;
        },
        updateSelection(v) {
            if (v[0]) {
                this.selected_bank_id = v[0].id;
            }
            if(v.id){
                this.selected_bank_id = v.id;
            }
        },
        setSelected: function (v) {
            this.selected_bank_id = v.id;
        },
        setSelectedIds: function (v) {
            this.selected_bank_ids = v.map(v=> {return v.id}) ;
        }
    }
}